import { IPaginatedResponse, IResponse } from '../../../model';
import { ICotizacionMensaje } from '../../../operaciones/model/ICardEdit';
import ServiceBase from '../../../servicebase';
import { ICotizacion } from '../model';

export default class CotizacionService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<ICotizacion>> => 
    this.GetFetch<IResponse<ICotizacion>>('entity/cotizacion', data);

  find = (data:{ 
    pageIndex?: number, pageSize?: number, sort?: string, 
    creafechaDesde?: string, creafechaHasta?: string, 
    estado?: string, codigo?: string, idcotizador?: number, idcliente?: number, acceso?: string, 
    fechadesdeDesde?: string, fechadesdeHasta?: string, fechahastaDesde?: string, fechahastaHasta?: string, 
    email?: string, whatsapp?: string, codigodescuento?: string, idorigen?: number, iddestino?: number,
    agruparDuplicados?: boolean,
  }) : Promise<IPaginatedResponse<ICotizacion>> => 
    this.GetFetch<IPaginatedResponse<ICotizacion>>('entity/cotizacion/find', data);

  upsert = (data:ICotizacion) : Promise<IResponse<ICotizacion>> => 
    this.PostFetch<IResponse<ICotizacion>>('entity/cotizacion', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/cotizacion', data);

    
  upsertMensaje = (data:{ idcotizacion?: number, texto?: string }) : Promise<IResponse<ICotizacionMensaje>> => 
    this.PostFetch<IResponse<ICotizacionMensaje>>('entity/cotizacionmensaje', data);
}
